import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import AccessAlarmsOutlinedIcon from '@mui/icons-material/AccessAlarmsOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {createTheme, Theme, ThemeProvider} from '@mui/material/styles';
import {
    selectBackgroundAudio, selectCounter,
    selectSleepPeriod,
    selectStatus,
    selectWorkoutPeriod,
    setBackgroundAudio,
    setSleepPeriod,
    setWorkoutPeriod,
    switchStatus
} from "./yogaSlice"
import {useAppDispatch, useAppSelector} from "../../app/hooks";

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#5b2101',
        }
    },
})

export function ExerciseCounter(){
    const counter = useAppSelector(selectCounter);
    const status = useAppSelector(selectStatus);
    const disabled = status === 'workout'
    const dateText = new Date(counter * 1000).toISOString().substr(11,8)
    return (
        <div>
            {disabled && <div>{dateText}</div>}
        </div>
    )
}

function checkCounterValue(counterValue: number): String {
    if (counterValue === 0){
        return ""
    }else{
        return counterValue.toString()
    }
}

function setCounterValue(counterValue: String): number {
    if (counterValue.length === 0){
        return 0
    }else {
        const retValue = Number(counterValue.replace(/^\s+|\s+$/g, ''))
        return Math.max(0, retValue)
    }
}

export function YogaCounter() {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        dispatch(switchStatus())
    }


    const sleepPeriod = checkCounterValue(useAppSelector(selectSleepPeriod));
    const workoutPeriod = checkCounterValue(useAppSelector(selectWorkoutPeriod));
    const backgroundAudio = useAppSelector(selectBackgroundAudio);
    const status = useAppSelector(selectStatus);
    const disabled = status === 'workout'
    const dispatch = useAppDispatch();

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline/>
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{
                        m: 1,
                        color:  (theme: Theme) => theme.palette.text.primary,
                        bgcolor: (theme: Theme) => theme.palette.primary.main}}>
                        <AccessAlarmsOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Yoga counter
                    </Typography>
                    <ExerciseCounter/>
                    <Box component="form" onSubmit={handleSubmit} sx={{mt: 3}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    name="Clean period"
                                    type="number"
                                    required
                                    fullWidth
                                    id="sleepPeriod"
                                    label="Sleep Period"
                                    autoFocus={!disabled}
                                    value={sleepPeriod}
                                    disabled={disabled}
                                    onChange={(e) => dispatch(setSleepPeriod(setCounterValue(e.target.value)))}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    type="number"
                                    id="workoutPeriod"
                                    label="Cleaning Period"
                                    name="workout"
                                    value={workoutPeriod}
                                    disabled={disabled}
                                    onChange={(e) => dispatch(setWorkoutPeriod(setCounterValue(e.target.value)))}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    name="backgroundAudio"
                                    required
                                    fullWidth
                                    id="backgroundAudio"
                                    label="Background Audio"
                                    value={backgroundAudio}
                                    disabled={disabled}
                                    onChange={(e) => dispatch(setBackgroundAudio(e.target.value))}
                                />
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{mt: 3, mb: 2}}
                        >
                            {disabled ? 'End Exercise' : 'Start Exercise'}
                        </Button>
                    </Box>
                </Box>
            </Container>
        </ThemeProvider>
    )
        ;
}